/**
 * @copyright Copyright (c) Agence ink
 * Code by Mathieu V.
 */

// This script detects a payment submit button and shows a icon-loading once it's clicked
// Requires the following structure to work properly
//
//  .pay
//    button
//    .loader style: display:none;
//  /.pay
//
// Will also remove "Cancel" button(s) [.cancel-cart] on screen, if any

export const payWait = () => {
  ///////
  let payContainers = document.querySelectorAll('.pay');
  if (payContainers.length > 0) {
    for (let currentContainer of payContainers) {
      let payButton = currentContainer.querySelector('button');
      let loader = currentContainer.querySelector('.loader');
      let cancelBtns = document.querySelectorAll('.cancel-cart');
      
      if (payButton) {
          payButton.addEventListener('click', () => {
          payButton.style.visibility = "hidden";
          loader.style.display = "block";
          payButton.style.pointerEvents = "none";
          for (let currentCancel of cancelBtns) {
            currentCancel.style.display = "none";
            currentCancel.style.pointerEvents = "none";
          }
        });
      }
    }
  }
  return;
  ///////
}
